import { FC } from "react";
import Button, { BUTTON_VARIANTS } from "components/shared/Button/Button";
import styles from "./CreateDocument.module.sass";

interface FinishProps {
	fileName: string;
	nextStep: () => void;
	close: () => void;
	load: boolean;
}

const Finish: FC<FinishProps> = ({ fileName, load, nextStep, close }) => {
	return (
		<div>
			<div className={styles.finish}>
				<div className={styles.fileName}>
					<div className={styles.file} />
					{fileName}
				</div>
				<div className={styles.btn_group}>
					<Button disabled={load} full variant={BUTTON_VARIANTS.OUTLINED} onClick={close} className={styles.button}>
						Отменить
					</Button>
					<Button loading={load} full onClick={nextStep} className={styles.button}>
						Готово
					</Button>
				</div>
			</div>
		</div>
	);
};

export default Finish;
